import { AxiosPromise } from "axios"
import { cvApi } from "./api"

export const getAutosuggest = (params: string): AxiosPromise =>
  cvApi(`/autosuggest/${params}`, {
    method: "GET"
  })
